import cn from "classnames";
import Styles from "../Icon.module.scss";
import { IconProps, IconSizes } from "../icon-prop-types";

export const NotGoingIcon = ({ fill = "red", size = "xsmall" }: IconProps) => {
  const fillStyles = cn(Styles[fill], Styles.fill);
  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox={`0 0 15 15`}
      role="img"
    >
      <title>Responded Not Going</title>
      <g fill="none" fillRule="evenodd">
        <circle className={fillStyles} cx={7} cy={7} r={6} />
        <path
          d="M7.909 7l2.403-2.402a.643.643 0 0 0-.91-.91L7 6.091 4.597 3.688a.643.643 0 0 0-.91.91L6.09 7 3.687 9.402a.645.645 0 0 0 .455 1.098.644.644 0 0 0 .455-.188L7 7.909l2.402 2.403a.644.644 0 0 0 .91-.91L7.91 7z"
          fill="#FFF"
        />
        <circle stroke="#FFF" cx={7} cy={7} r={6.5} />
      </g>
    </svg>
  );
};
export default NotGoingIcon;
